import { render, staticRenderFns } from "./EditCustomDocLocation.vue?vue&type=template&id=258048e6&scoped=true&"
import script from "./EditCustomDocLocation.vue?vue&type=script&lang=js&"
export * from "./EditCustomDocLocation.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomDocLocation.vue?vue&type=style&index=0&id=258048e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258048e6",
  null
  
)

export default component.exports